<template>
  <v-container fluid grid-list-xl>
    <v-layout row wrap>
      <v-flex xs12>
        <h2>
          {{ $t('completeFiscalForm') }}
        </h2>
      </v-flex>

      <v-flex xs12>
        <v-form @submit.prevent="submit">
          <v-card class="mt-4">
            <v-card-text>
              <v-container fluid grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm12 md12>
                    <v-radio-group
                      :label="`${$t('selectTaxRegime')}:`"
                      v-model="taxFiscalDatum.tax_regime"
                      v-validate="'required'"
                      :error-messages="errors.collect('selectTaxRegime')"
                      data-vv-name="selectTaxRegime"
                      :data-vv-as="$t('selectTaxRegime')"
                      row
                      required
                      @change="resetValidations"
                    >
                      <v-radio :label="$t('list.taxRegimes.physical')" value="physical"></v-radio>
                      <v-radio :label="$t('list.taxRegimes.moral')" value="moral"></v-radio>
                    </v-radio-group>
                  </v-flex>

                  <v-flex xs12 sm12 md4 v-if="taxFiscalDatum.tax_regime == 'physical'">
                    <v-text-field v-model="taxFiscalDatum.name"
                                  name="name"
                                  :label="$t('taxFiscalData.fullName')"
                                  v-validate="'required'"
                                  :error-messages="errors.collect('name')"
                                  data-vv-name="name"
                                  :data-vv-as="$t('taxFiscalData.fullName')"
                                  ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm12 md6 v-if="taxFiscalDatum.tax_regime == 'moral'">
                    <v-text-field v-model="taxFiscalDatum.name"
                                  name="business_name"
                                  :label="$t('taxFiscalData.businessName')"
                                  v-validate="'required'"
                                  :error-messages="errors.collect('business_name')"
                                  data-vv-name="business_name"
                                  :data-vv-as="$t('taxFiscalData.businessName')"
                                  ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm12 md4 v-if="taxFiscalDatum.tax_regime == 'physical'">
                    <v-text-field v-model="taxFiscalDatum.rfc_curp"
                                  name="rfc"
                                  :label="$t('taxFiscalData.rfcOrCurp')"
                                  v-validate="'required'"
                                  :error-messages="errors.collect('rfc')"
                                  data-vv-name="rfc"
                                  :data-vv-as="$t('taxFiscalData.rfcOrCurp')"
                                  ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm12 md6 v-if="taxFiscalDatum.tax_regime == 'moral'">
                    <v-text-field v-model="taxFiscalDatum.rfc_curp"
                                  name="curp"
                                  :label="$t('taxFiscalData.rfcOrCurp')"
                                  v-validate="'required'"
                                  :error-messages="errors.collect('curp')"
                                  data-vv-name="curp"
                                  :data-vv-as="$t('taxFiscalData.rfcOrCurp')"
                                  ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm12 md4 v-if="taxFiscalDatum.tax_regime == 'physical'">
                    <v-text-field v-model="taxFiscalDatum.social_url"
                                  name="social_url"
                                  :label="$t('taxFiscalData.socialUrl')"
                                  v-validate="'required'"
                                  :error-messages="errors.collect('social_url')"
                                  data-vv-name="social_url"
                                  :data-vv-as="$t('taxFiscalData.socialUrl')"
                                  ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm12 md6 v-if="taxFiscalDatum.tax_regime">
                    <v-text-field :label="$t('taxFiscalData.passport')" @click="pickDocImageFile" v-model="docImageName" prepend-icon="attach_file"></v-text-field>
                    <input type="file" style="display: none" ref="docImage" accept="image/*,application/pdf" @change="onDocImagePicked">
                  </v-flex>
                  <v-flex xs12 sm12 md6 v-if="taxFiscalDatum.tax_regime == 'moral'">
                    <v-text-field :label="$t('taxFiscalData.articles')" @click="pickArticleImageFile" v-model="articleImageName" prepend-icon="attach_file"></v-text-field>
                    <input type="file" style="display: none" ref="articleImage" accept="image/*,application/pdf" @change="onArticleImagePicked">
                  </v-flex>

                  <v-flex xs12 sm12 md12 v-if="taxFiscalDatum.tax_regime" style="padding-bottom: 0">
                    <v-radio-group
                      :label="`${$t('taxFiscalData.interests')}:`"
                    >
                    </v-radio-group>
                  </v-flex>

                  <v-flex xs5 sm5 md12 v-if="taxFiscalDatum.tax_regime" style="padding-top: 0">
                    <v-checkbox v-for="(service) in fiscalServices" :key="service"
                                class="ma-0"
                                v-model="taxFiscalDatum.services"
                                :label="$t(`taxFiscalData.${service}`)"
                                :value="service"
                                color="primary"
                                ></v-checkbox>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" flat @click="back" :loading="loading" :disabled="loading">{{ $t('cancel') }}</v-btn>
              <v-btn color="primary" dark :loading="loading" :disabled="loading" type="submit">{{ $t('save') }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import TaxFiscalDatum from '@/client/tax-fiscal-datum'

export default {
  name: 'taxFiscalDataForm',

  props: {},

  data () {
    return {
      loading: false,
      carrier: {},
      docImageName: '',
      docImage: '',
      articleImageName: '',
      articleImage: '',
      imageName: '',
      taxFiscalDatum: {
        services: []
      },
      fiscalServices: [
        'ltl',
        'international',
        'national',
        'supplies',
        'ecommerce'
      ],
      articleImageType: 'image',
      docImageType: 'image'
    }
  },

  components: {
  },

  computed: {
  },

  methods: {
    async submit () {
      const isValid = await this.$validator.validateAll()
      if (!isValid) { return }

      this.loading = true
      try {
        const formData = new FormData()

        formData.append('tax_fiscal_datum[name]', this.taxFiscalDatum.name)
        formData.append('tax_fiscal_datum[rfc_curp]', this.taxFiscalDatum.rfc_curp)
        formData.append('tax_fiscal_datum[services][]', this.taxFiscalDatum.services)
        formData.append('tax_fiscal_datum[tax_regime]', this.taxFiscalDatum.tax_regime)
        formData.append('tax_fiscal_datum[social_url]', this.taxFiscalDatum.social_url)

        if (this.docImage) {
          formData.append('tax_fiscal_datum[doc_image]', this.docImage)
        }

        if (this.articleImage) {
          formData.append('tax_fiscal_datum[article_image]', this.articleImage)
        }

        await TaxFiscalDatum.saveFormData(formData)
        this.setNotification({
          color: 'success',
          message: this.$t('userFiscalVerified')
        })

        this.goTo('dashboard')
        // this.back()
      } catch (err) {
        this.handleErr(err)
      }
      this.loading = false
    },

    pickDocImageFile () {
      this.$refs.docImage.click()
    },

    onDocImagePicked (e) {
      this.docImage = e.target.files[0]
      this.docImageName = this.docImage.name
    },

    pickArticleImageFile () {
      this.$refs.articleImage.click()
    },

    onArticleImagePicked (e) {
      this.articleImage = e.target.files[0]
      this.articleImageName = this.articleImage.name
    },

    async resetValidations () {
      // this.$refs.observer.reset();
      this.$validator.reset();

      this.$validator.validateAll();
      // this.erros.clear();
    },

    setImageType (uploadName, fileName) {
      try {
        this[`${ uploadName }ImageType`] = (fileName.split('.')[1] == 'pdf') ? 'pdf' : 'image'
      } catch (err) {
        this[`${ uploadName }ImageType`] = 'image'
      }
    }
  },

  watch: {
  },

  async mounted () {
    this.taxFiscalDatum = new TaxFiscalDatum({
      services: []
    })
  }
}
</script>
